import { defineBlock, ChildrenBlock, useChildrenBlocks, useEditor } from '@smartfire/js-block-engine';
import { useState } from 'react';
import style from './block.module.scss';

function Onglets() {
    const { isEditing } = useEditor();
    const { children, Child } = useChildrenBlocks();
    const [ongletOpen, setOngletOpen] = useState(null);

    return (
        <div className={style.blockOnglets}>
            {isEditing ? (
                <ChildrenBlock
                    gutenbergEditorConfig={{
                        allowedBlocks: ['smartfire/onglets---onglet'],
                        template: [
                            ['smartfire/onglets---onglet'],
                            ['smartfire/onglets---onglet'],
                            ['smartfire/onglets---onglet'],
                            ['smartfire/onglets---onglet'],
                        ],
                    }}
                    className={style.blockOnglets}
                />
            ) : (
                children &&
                children.map((_, index) => (
                        <Child key={index} index={index} ongletOpen={ongletOpen} number={index} setOngletOpen={setOngletOpen} />
                ))
            )}
        </div>
    );
}

export default defineBlock({
    Block: Onglets,
    smartProps: {},
    setup: {
        title: 'Onglets',
    },
});
